import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from '../ui';

/** Registers the service worker and offers "Reload" when a new version is waiting. */
export function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh],
    offlineReady: [offlineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Look for updates hourly while the app stays open.
      if (registration) setInterval(() => void registration.update(), 60 * 60 * 1000);
    },
  });

  useEffect(() => {
    if (needRefresh)
      toast.info(t('pwa.updateAvailable'), {
        label: t('pwa.reload'),
        run: () => void updateServiceWorker(true),
      });
  }, [needRefresh, t, updateServiceWorker]);

  useEffect(() => {
    if (offlineReady) toast.success(t('pwa.offlineReady'));
  }, [offlineReady, t]);

  return null;
}
